module.exports = __webpack_public_path__ + "media/images/icons/flags/JO-1d6988f2b620152f315138628ba29f53.svg";